import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map } from 'immutable';

import { Card } from '../../helpers/Card';
import { ProjectMenu } from '../ProjectMenu';
import { Approvals } from './Approvals';

import style from './style.module.css';

const DELETE_APPROVAL_MENU_ID = 'projectApprovalTemplateContextMenu';

/**
 * Project component.
 *
 * @param props {Object}.
 */
const MidPanelComponent = ({
  approvals,
  noApprovals,
  common,
  approvalColumns,
  onSort,
  onRowClick,
  onRowDoubleClick,
  onRowInsert,
  onRowChange,
  onNoApprovalDoubleClick,
  onDeleteApprovalRow,
}) => (
  <Card className={style.host} flush>
    <Approvals
      approvalColumns={approvalColumns}
      approvals={approvals}
      common={common}
      contextId={DELETE_APPROVAL_MENU_ID}
      noApprovals={noApprovals}
      onChange={onRowChange}
      onClick={onRowClick}
      onDoubleClick={onRowDoubleClick}
      onInsert={onRowInsert}
      onNoApprovalDoubleClick={onNoApprovalDoubleClick}
      onSort={onSort}
    />
    <ProjectMenu id={DELETE_APPROVAL_MENU_ID} onDelete={onDeleteApprovalRow} />
  </Card>
);

MidPanelComponent.propTypes = {
  approvalColumns: PropTypes.instanceOf(List).isRequired,
  approvals: PropTypes.instanceOf(List).isRequired,
  common: PropTypes.instanceOf(Map).isRequired,
  noApprovals: PropTypes.instanceOf(List).isRequired,
  onDeleteApprovalRow: PropTypes.func.isRequired,
  onRowChange: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowInsert: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
};

export const MidPanel = memo(MidPanelComponent);
